// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MRI4","right":"styles_right__iBDwg"};